module.exports = __webpack_public_path__ + "img/rare-box.840e7b96.png";